import eventBus from '@/services/eventBus'
import { INotificationWsMessage } from './notifications.types'

const notificationReceived = async (data: INotificationWsMessage) => {
  eventBus.pub('notification.received', data)
}

const notificationService = { notificationReceived }
export default notificationService
